import {
    useForecastOverViewDropDownFilterMutation,
    useGetFeatchForecastoverViewMutation,
    useGetForecastOverviewBarchatMutation,
    useGetForecastoverViewMapMutation,
    useGetForecastOverViewMapStoreLevelMutation
} from "../api/demandApi";

export const useForecastOverViewDropDownFilter = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useForecastOverViewDropDownFilterMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    }
}

export const useGetFeatchForecastoverView = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetFeatchForecastoverViewMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    }
}

export const useGetForecastOverviewBarchat = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetForecastOverviewBarchatMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    }
}

export const useGetForecastoverViewMap = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetForecastoverViewMapMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    }
}

export const useGetForecastOverViewMapStoreLevel = () => {
    const [mutate, { isLoading, isSuccess, isError, error, data }] = useGetForecastOverViewMapStoreLevelMutation();
    return {
        mutate,
        isLoading,
        isSuccess,
        isError,
        error,
        data
    }
}